module.exports = __webpack_public_path__ + "static/img/zixun.3c8a2161.svg";